import {Component, ElementRef, OnInit, ViewChild} from "@angular/core";
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import {email} from 'ng2-validation/dist/email';
import {AuthService} from '../services/auth-service/auth-service.service';
import {Constants} from '../util/Constants';
import '../util/custom-alert/custom-alert.component';
import {ErrorService} from '../util/error_service/error.service';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
  providers: [AuthService]
})
export class SignInComponent implements OnInit {

  public signInText: string;
  public staySignedIn = false;
  public vendorTitle : string = Constants.VENDOR;

  @ViewChild('seePassword') seePassword: ElementRef;

  public authPayload: any = {
    username: '',
    password: ''
  };



  public signInForm: FormGroup;
  public accessToken: string;
  public refreshToken: string;
  public status: number;
  public signingIn: boolean;
  public errorMsg: any;


  constructor(public router: Router, public auth: AuthService, public error: ErrorService, public fb: FormBuilder) {
    this.signingIn = false;
    this.signInText = 'Sign in';
    this.createForm();
  }

  seePass() {
      this.seePassword.nativeElement.setAttribute('type', 'text');
  }

  hidePass() {
    this.seePassword.nativeElement.setAttribute('type', 'password');
  }

  ngOnInit() {
    if (localStorage.getItem(Constants.ACCESS_TOKEN)){
      // redirect the user
      this.router.navigate(['/admin/dashboard']);
      return false;
    }
  }

  createForm() {
    this.signInForm = this.fb.group({
      username: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]]
    });
  }

  onSubmit() {
    this.signingIn = true;
    this.signInText = 'Authenticating...';
    // console.log(this.staySignedIn);
    this.authenticate();
  }

  /**
   * authenticate user
   */
  public authenticate() {
    this.auth.auth(this.signInForm.value).subscribe(
      data => {
        this.accessToken = data.accessToken;
        this.refreshToken = data.refreshToken;
        // console.log(this.accessToken);
        // console.log(this.refreshToken);

        this.saveToken();
        if (this.accessToken != null && this.refreshToken != null) {
          this.getProfile();
        }
      },
      err => {
         this.errorMsg = this.error.loggedOutError(err);
          this.signingIn = false;
        this.signInText = 'Sign in';
      },
    )
  }

  /**
   * save token
   * @param data
   */
  public saveToken() {
    this.auth.saveToken(this.accessToken, this.refreshToken);
  }

  /**
   * get agent profile
   * @param accessToken
   */
  public getProfile() {
    this.auth.getProfile(this.accessToken).subscribe(
      response => {
        this.auth.saveProfile(JSON.stringify(response));
       // localStorage.setItem(Constants.PROFILE, JSON.stringify(response));
        this.status = response.data[0].active;
        // console.log('Status is ' + this.status);
        if (this.status == 1) {
          // console.log('logged in');
          this.navigate();
        }
      },
      err => {
        // console.log(err);
        this.error = JSON.parse(err._body);
        // console.log(this.error);
      }
    )
  }
  /**
   * navigate to agent dashboard
   */
  public navigate() {
    this.router.navigate([Constants.ADMIN_DASHBOARD]);
    this.signingIn = false;
    this.signInText = 'Sign in';
  }
}



// WEBPACK FOOTER //
// ./src/app/sign-in/sign-in.component.ts